var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    _vm._g(
      {
        ref: "_in",
        staticClass: "_btn",
        class: ((_obj = {}),
        (_obj[_vm.tone] = _vm.tone),
        (_obj[_vm.appearance] = _vm.appearance),
        (_obj._busy = _vm.busy),
        _obj),
        style: { width: _vm.width, height: _vm.height },
        attrs: {
          type: "button",
          id: _vm.id,
          disabled: _vm.disabled || _vm.busy,
          inert: _vm.inert,
          tabindex: _vm.inert ? -1 : _vm.tabindex
        }
      },
      _vm.__on
    ),
    [
      _vm._t("default", [_vm._v("﻿")]),
      _vm.busy
        ? _c(
            "span",
            { staticClass: "_busyi" },
            [_vm._t("busy", [_c("ib-progress-dots")])],
            2
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }